// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__PaSQX","img":"index_img__5Sy3J","title":"index_title__ZWLRO","desc":"index_desc__8k89s","button":"index_button__X3hjZ"};